import * as React from "react";
import { FacesheetCard } from "@coverme/cards";
import {
    FA,
    Gov,
    Curae,
    Private,
    NoCoverage,
    Simple,
    CardToDetailedTabbedResult,
    MedicareDetailedTabbedResult,
} from "@coverme/cards";
import {
    doesProvidedCoverageMatchesVerified,
    jsonContainErrors,
    getJsonErrors,
    formatDisplayDates,
} from "../../services/coverageService";

import "./FacesheetCoverage.scss";
import { InterviewCoverageCard } from "../InterviewCoverageSummary/InterviewCoverageCard";

export const FacesheetCoverage = ({ customerId, encounterId, coverage, patientFullName: thePatient }) => {
    const primaryCoverage = coverage.primaryCoverage;
    let secondaryCoverage = coverage.supplementalCoverage;
    let hasSecondaryCoverage =
        coverage.supplementalCoverage &&
        coverage.supplementalCoverage.startDate != "" &&
        coverage.supplementalCoverage.startDate != null &&
        coverage.supplementalCoverage !== null;

    const autoProvidedPersonCoverages = coverage.coverageSummary?.personCoverages?.filter(
        x => x.coverageSource.name != "Interview"
    );

    function getCards(coverage) {
        let cards = [];

        if (
            coverage &&
            ((coverage.coverageSummary?.coverageSource && coverage.coverageSummary) ||
                coverage.coverageSummary?.personCoverages?.length > 0)
        ) {
            cards = coverage?.coverageSummary?.personCoverages
                .filter(x => x.isActive)
                .map(x => {
                    if (x.coverageJson && jsonContainErrors(JSON.parse(x.coverageJson))) {
                        return (
                            <CardToDetailedTabbedResult
                                card={
                                    <div className="facesheet-coverage-card facesheet-coverage-gov">
                                        <p className="facesheet-coverage-card__title">
                                            Summary is not currently available
                                        </p>
                                        <div className="facesheet-coverage-gov__container">
                                            <div className="facesheet-coverage-gov__info">
                                                Check details tab for more information
                                            </div>
                                        </div>
                                    </div>
                                }
                                json={getJsonErrors(JSON.parse(x.coverageJson)).validationMessages}
                                key={x.GlobalId}
                            />
                        );
                    }
                    if (x.healthInsuranceType?.name === "Insurance") {
                        const selectedCard = (
                            <div>
                                <Private
                                    title={"Coverage"}
                                    plan={x.plan}
                                    memberId={x.memberId}
                                    coPays={{
                                        ER: x.copay?.erInPlanNetwork == null ? "  -  " : x.copay.erInPlanNetwork,
                                        Office: x.copay?.office == null ? "  -  " : x.copay.office,
                                        Specialist:
                                            x.copay?.specialistInPlanNetwork == null
                                                ? "  -  "
                                                : x.copay.specialistInPlanNetwork,
                                    }}
                                    deductibleRemaining={
                                        x.remainingDeductible?.inPlanNetwork == null
                                            ? "  -  "
                                            : x.remainingDeductible.inPlanNetwork
                                    }
                                    outOfPocketRemaining={
                                        x.remainingOutOfPocket?.inPlanNetwork == null
                                            ? "  -  "
                                            : x.remainingOutOfPocket.inPlanNetwork
                                    }
                                    effectiveDate={formatDisplayDates(x.effectiveDate)}
                                    address={x.address}
                                    phoneNumber={x.phoneNumber}
                                    groupNumber={x.groupNumber}
                                    companyName={x.companyName}
                                    employer={x.employer}
                                    key={x.GlobalId}
                                />
                            </div>
                        );

                        if (x.coverageJson) {
                            return (
                                <CardToDetailedTabbedResult
                                    card={selectedCard}
                                    showDetailsTabLabel={true}
                                    json={JSON.parse(x.coverageJson)}
                                    key={x.GlobalId}
                                />
                            );
                        } else {
                            return selectedCard;
                        }
                    }
                    if (x.healthInsuranceType?.name === "Medicare") {
                        if (x.coverageJson) {
                            return <MedicareDetailedTabbedResult json={JSON.parse(x.coverageJson)} key={x.GlobalId} />;
                        } else {
                            return (
                                <Gov
                                    title={`${x.healthInsuranceType.name} Identified`}
                                    subtitle={`Available information suggests that ${thePatient} is currently covered under this program.`}
                                    plan={x.plan}
                                    memberId={x.memberId}
                                    effectiveDate={formatDisplayDates(x.effectiveDate)}
                                    address={x.address}
                                    phoneNumber={x.phoneNumber}
                                    managedCareCoordinator={
                                        x.managedCareCoordinators ? x.managedCareCoordinators.join(",") : null
                                    }
                                    key={x.GlobalId}
                                />
                            );
                        }
                    }
                    if (x.healthInsuranceType?.name === "Medicaid") {
                        const selectedCard = (
                            <Gov
                                title={`${x.healthInsuranceType.name} Identified`}
                                subtitle={`Available information suggests that ${thePatient} is currently covered under this program.`}
                                plan={x.plan}
                                memberId={x.memberId}
                                effectiveDate={formatDisplayDates(x.effectiveDate)}
                                address={x.address}
                                phoneNumber={x.phoneNumber}
                                managedCareCoordinator={
                                    x.managedCareCoordinators ? x.managedCareCoordinators.join(",") : null
                                }
                                key={x.GlobalId}
                            />
                        );

                        if (x.coverageJson) {
                            return (
                                <CardToDetailedTabbedResult
                                    card={selectedCard}
                                    showDetailsTabLabel={true}
                                    json={JSON.parse(x.coverageJson)}
                                    key={x.GlobalId}
                                />
                            );
                        } else {
                            return selectedCard;
                        }
                    }
                    if (x.healthInsuranceType?.name === "VA") {
                        const selectedCard = (
                            <Gov
                                title={`${x.companyName} Identified`}
                                subtitle={`Available information suggests that ${thePatient} is currently covered under this program.`}
                                plan={x.plan}
                                memberId={x.memberId}
                                effectiveDate={formatDisplayDates(x.effectiveDate)}
                                address={x.address}
                                phoneNumber={x.phoneNumber}
                                key={x.GlobalId}
                            />
                        );

                        if (x.coverageJson) {
                            return (
                                <CardToDetailedTabbedResult
                                    card={selectedCard}
                                    showDetailsTabLabel={true}
                                    json={JSON.parse(x.coverageJson)}
                                    key={x.GlobalId}
                                />
                            );
                        } else {
                            return selectedCard;
                        }
                    }
                    if (x.healthInsuranceType?.name === "Financial Assistance") {
                        return (
                            <FA
                                title={`${x.companyName} Identified`}
                                subtitle={`Available information suggests that ${thePatient} is currently covered under this program.`}
                                plan={x.plan}
                                memberId={x.memberId}
                                effectiveDate={formatDisplayDates(x.effectiveDate)}
                                expirationDate={formatDisplayDates(x.expirationDate)}
                                address={x.address}
                                phoneNumber={x.phoneNumber}
                                key={x.GlobalId}
                                discount={"10%"}
                            />
                        );
                    }
                    if (x.healthInsuranceType?.name === "Other") {
                        // TODO: needs refactoring
                        if (x.companyName.includes("Bank")) {
                            return (
                                <Curae
                                    title={`${x.companyName} Identified`}
                                    subtitle={`Available information suggests that ${thePatient} is currently covered under this program.`}
                                    availableCredit={"-"}
                                    creditLimit={"-"}
                                    plan={x.plan}
                                    memberId={x.memberId}
                                    effectiveDate={x.effectiveDate}
                                    expirationDate={formatDisplayDates(x.expirationDate)}
                                    address={x.address}
                                    phoneNumber={x.phoneNumber}
                                    key={x.GlobalId}
                                />
                            );
                        } else {
                            return (
                                <SummaryPrivateNotReturned
                                    address={x.address}
                                    phoneNumber={x.phoneNumber}
                                    companyName={x.companyName}
                                    key={x.GlobalId}
                                />
                            );
                        }
                    }
                    if (x.healthInsuranceType?.name === "LongTermCare") {
                        const selectedCard = (
                            <Simple
                                title={`${x.companyName} Identified`}
                                insuranceType={x.healthInsuranceType.name}
                                companyName={x.companyName}
                                memberId={x.memberId}
                                key={x.GlobalId}
                            />
                        );

                        if (x.coverageJson) {
                            return (
                                <CardToDetailedTabbedResult
                                    card={selectedCard}
                                    showDetailsTabLabel={true}
                                    json={JSON.parse(x.coverageJson)}
                                    key={x.GlobalId}
                                />
                            );
                        } else {
                            return selectedCard;
                        }
                    }
                });

            if (coverage.hasCoverage === true && hasSecondaryCoverage) {
                cards.push(
                    <Simple
                        title={"Supplemental Coverage Identified"}
                        insuranceType={secondaryCoverage.typeOfCoverage}
                        companyName={secondaryCoverage.companyName}
                        memberId={secondaryCoverage.memberNumber}
                    />
                );
            }
        } else if (coverage?.coverageSummary?.personCoverages == null) {
            cards = [];
        }

        if (cards.length === 0) {
            return (
                <NoCoverage
                    title={"No Health Coverage Identified"}
                    subtitle={"Available information suggests that the patient has no current insurance."}
                />
            );
        }

        return cards;
    }

    const cards = getCards(coverage);

    return (
        <div className="facesheet-coverage">
            {/*<div className="facesheet-coverage__content">{cards}</div>*/}
            {/* <HealthBenefitPlanCoverage
                                                        coverageValue={values.primaryCoverage.typeOfCoverage}
                                                        personCoverages={autoProvidedPersonCoverages}

                                                    /> */}
            <div className="facesheet-coverage__content">
                <InterviewCoverageCard
                    customerId={customerId}
                    encounterId={encounterId}
                    coverage={coverage}
                    thePatient={thePatient}
                    title={`Coverage results`}
                    coverageValue={primaryCoverage.typeOfCoverage}
                    personCoverages={autoProvidedPersonCoverages}
                    forFacesheet={true}
                />
            </div>
        </div>
    );
};
